import React from 'react';
import Page from '../layout/growz/Page';
import { isDevelopment } from '../utils';
import Error404 from './common/error-404';
// import axios from 'axios';
// import { Typography } from '@material-ui/core';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

function TestPage() {
  // const [req, setReq] = useState(500);

  if (!isDevelopment()) {
    return <Error404 />;
  }

  // const api = () => {
  //   const newMessage = [
  //     {
  //       role: 'user',
  //       content: 'Teri maa ka',
  //     },
  //   ];
  //   const requestBody = {
  //     messages: [...newMessage],
  //   };

  //   axios.post('https://ai.sellergeni.com/api/chat', requestBody);
  // };

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (req > 0) {
  //       api();
  //       setReq(req - 1);
  //     }
  //   }, 10000);
  // }, [req]);

  return (
    <Page title="Test">
      {/* <div className="flexAlignCenter">
        <Typography variant="h1">Requests pending - {req} </Typography>
        <div>
          <div
            style={{
              height: '40px',
              background: '#d3d3d3',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              padding: '0 1rem',
              marginLeft: '1rem',
              justifyContent: 'center',
              animation: 'liveBlink 0.5s step-end infinite alternate',
            }}
          >
            <Typography
              variant="body2"
              style={{
                fontWeight: 600,
                color: '#000000',
                opacity: 0.8,
              }}
            >
              Live
            </Typography>
            <FiberManualRecordIcon
              style={{
                color: 'red',
                fontSize: '18px',
                marginLeft: '4px',
                opacity: 0.8,
              }}
            />
          </div>
        </div>
      </div>
      <Typography variant="body1">Total requests - 500 </Typography> */}
    </Page>
  );
}

export default TestPage;
